'use strict';

var _ = require('lodash');
var LogService = function LogService($injector, configurationService) {
  var $state;
  var restangular;
  var WAIT_TIME = 5000;
  var MAX_WAIT_TIME = 5000;
  var REVIEW_WAIT_TIME = 1000;
  var MAX_REVIEW_WAIT_TIME = 1000;
  var logMessageQueue = [];
  var logMetricQueue = [];
  var logTimingQueue = [];
  var logUserActionQueue = [];
  function formatMessage(objs) {
    return _.chain(objs).join(' ').value();
  }
  function postLogs(logs, endpoint) {
    if (!restangular) {
      restangular = $injector.get('Restangular');
    }
    if (_.isArray(logs) && logs.length > 0 || _.has(logs, 'value') && _.isArray(logs.value) && logs.value.length > 0) {
      restangular.one(endpoint).customPOST(logs, '', {
        noSpinner: true
      });
    }
  }
  function getWorkflow() {
    if (!$state) {
      $state = $injector.get('$state');
    }
    var state = $state.current.name;
    var arrOfStr = state.split('.');
    return arrOfStr.length > 1 ? arrOfStr[1].split('-').join('_') : undefined;
  }
  function getUserId() {
    return configurationService.getUserId();
  }
  function addToLogMessageQueue(log) {
    var logEntry = {
      level: log.level,
      message: formatMessage(log.message),
      workflow: getWorkflow(),
      user: getUserId()
    };
    var existingLogEntry = _.find(logMessageQueue, logEntry);
    if (existingLogEntry) {
      existingLogEntry.count++;
    } else {
      logEntry.count = 1;
      logMessageQueue.push(logEntry);
    }
  }
  function addToLogMetricQueue(log) {
    var logEntry = {
      key: log.key,
      value: log.value,
      eventSubtype: log.eventSubtype,
      workflow: getWorkflow(),
      user: getUserId()
    };
    logMetricQueue.push(logEntry);
  }
  function addToLogTimingQueue(log) {
    var logEntry = {
      key: log.key,
      value: log.value,
      workflow: getWorkflow(),
      user: getUserId()
    };
    logTimingQueue.push(logEntry);
  }
  function addToUserActionQueue(userAction) {
    var logEntry = {
      domain: userAction.domain,
      key: userAction.key,
      type: userAction.type,
      timestamp: userAction.timestamp,
      userId: getUserId()
    };
    logUserActionQueue.push(logEntry);
  }
  function flushLogMessageQueue() {
    var logs = _.clone(logMessageQueue);
    logMessageQueue = [];
    postLogs(logs, 'log');
  }
  function flushLogMetricQueue() {
    var logs = _.clone(logMetricQueue);
    logMetricQueue = [];
    postLogs(logs, 'logMetrics');
  }
  function flushLogTimingQueue() {
    var logs = _.clone(logTimingQueue);
    logTimingQueue = [];
    postLogs(logs, 'logTimings');
  }
  function flushUserActionQueue() {
    var actions = _.clone(logUserActionQueue);
    logUserActionQueue = [];
    postLogs({
      value: actions
    }, 'userAction');
  }
  var flushLogMessageQueueDebounced = _.debounce(flushLogMessageQueue, WAIT_TIME, {
    maxWait: MAX_WAIT_TIME
  });
  var flushLogMetricQueueDebounced = _.debounce(flushLogMetricQueue, WAIT_TIME, {
    maxWait: MAX_WAIT_TIME
  });
  var flushLogTimingQueueDebounced = _.debounce(flushLogTimingQueue, WAIT_TIME, {
    maxWait: MAX_WAIT_TIME
  });
  var flushUserActionQueueDebounced = _.debounce(flushUserActionQueue, REVIEW_WAIT_TIME, {
    maxWait: MAX_REVIEW_WAIT_TIME
  });
  function logMessage(messsage) {
    addToLogMessageQueue(messsage);
    flushLogMessageQueueDebounced();
  }
  function logMetric(metric) {
    addToLogMetricQueue(metric);
    flushLogMetricQueueDebounced();
  }
  function logTiming(timing) {
    addToLogTimingQueue(timing);
    flushLogTimingQueueDebounced();
  }
  function logUserAction(userAction) {
    addToUserActionQueue(userAction);
    flushUserActionQueueDebounced();
  }
  function flush() {
    flushLogMessageQueueDebounced.flush();
    flushLogMetricQueueDebounced.flush();
    flushLogTimingQueueDebounced.flush();
    flushUserActionQueueDebounced.flush();
  }
  return {
    logMessage: logMessage,
    logMetric: logMetric,
    logTiming: logTiming,
    logUserAction: logUserAction,
    flush: flush
  };
};
LogService.$inject = ['$injector', 'ConfigurationService'];
module.exports = LogService;